<template>
  <div class="container">
    <div class="markup-tables">
      <table class="va-table vat-table--striped va-table--hoverable">
        <thead>
          <tr>
            <slot name="tableHeaders"></slot>
          </tr>
        </thead>

        <tbody :v-if="showTableBody">
          <slot name="tableBody"></slot>
        </tbody>
      </table>
    </div>
    <br />
    <slot name="paginationInfo">
      <div
        style="align-content:stretch"
        class="row flex-nowrap  justify--space-between"
      >
        <div :v-if="showTableBody">
          <h1 style="margin-top=5px">
            Displaying {{ displayFrom }} to {{ displayTo }} out of
            {{ paginationInfo.total }}
          </h1>
        </div>
        <va-pagination
          @input="setPage(page)"
          style="margin-top:0%"
          v-model="page"
          :pages="pages"
        >
        </va-pagination>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: ["showTableBody", "info"],
  data() {
    return {
      page: 1
    };
  },
  computed: {
    paginationInfo() {
      if (this.info === undefined) {
        return {
          total: 1,
          pageSize: 1,
          resultLength: 1
        };
      } else {
        return this.info;
      }
    },
    pages() {
      return this.showTableBody == false
        ? 1
        : Math.ceil(this.paginationInfo.total / this.paginationInfo.pageSize);
    },
    displayFrom() {
      if (this.page == 1 || this.paginationInfo.resultLength==0) {
        return 1;
      } else {
        return this.paginationInfo.pageSize * (this.page - 1);
      }
    },
    displayTo() {
      const testCase =
        this.paginationInfo.resultLength != 0 &&
        this.paginationInfo.total < this.paginationInfo.pageSize;

      if (this.page == 1 && testCase == true) {
        return this.paginationInfo.total;
      }

      if (this.paginationInfo.resultLength == 0) {
        return 1;
      } else if (this.pageSize != 1) {
        const calc =
          this.paginationInfo.pageSize + this.paginationInfo.resultLength;
        return this.paginationInfo.total < calc
          ? this.paginationInfo.pageSize
          : calc;
      }
    }
  },
  methods: {
    setPage(page) {
      this.$emit("pageChanged", this.page);
    }
  }
};
</script>
